import React, { useState, useEffect } from "react";
import { StyleSheet, View } from "react-native";
import AppConfig from "../../../config/AppConfig";
import ExitTutorialsButton from "../common/header/ExitTutorialsButton";
import headerStyles from "../common/header/headerStyles";

import Icons from "../common/icons/index";
import ImageComponent from "../common/ImageComponent";

export default function HomePageHeader({ controller, onAvatarClick }) {
  const [userAvatar, setUserAvatar] = useState();

  const goToMore = () => {
    if (controller != null) {
      if (controller.navigation != null && AppConfig.USE_DRAWER) {
        controller.navigation.openDrawer();
      } else {
        controller.changePage("feed", { selectedPage: "more", args: {} });
      }
    }
  };

  useEffect(() => {
    setUserAvatar(controller.state?.picture);
  }, []);

  return (
    <View style={[headerStyles.container]}>
      <View style={headerStyles.header}>
        <View style={headerStyles.leftContainer}>
          <Icons.MenuIcon onPress={goToMore} />
        </View>

        <View style={styles.logoContainer}>
          <ImageComponent
            image={require("../../../assets/WhiteHorizontal.png")}
            styles={{ width: 120, height: 36 }}
          />
        </View>

        {/* Exit tutorials */}
        <ExitTutorialsButton controller={controller} />

        <View style={headerStyles.rightContainer}>
          <View style={headerStyles.imageContainer}>
            <ImageComponent
              styles={styles.avatar}
              image={userAvatar}
              action={onAvatarClick}
            />
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 100,
  },
});
